import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Link } from 'react-router-dom';
import SVGIcon from './SVGIcon';
import switchImg from '../images/Switch.svg';
import { useSelector } from 'react-redux';


const ProfileDropdown = props => {

  const [dropDownOpen, setDropDown] = React.useState(false);

  const toggleDropDown = () => setDropDown(!dropDownOpen);

  const closeDropDown = () => setDropDown(false);

  const handelLogout = () => {
    closeDropDown();
    props.logOut();
  }

  const auth = useSelector(state => state.auth);

  return (
    <OutsideClickHandler onOutsideClick={closeDropDown}>
      <div className="ProfileDropdown">
        <button
          onClick={toggleDropDown}
          className={`ProfileDropdown_profile-button${
            dropDownOpen
              ? ' ProfileDropdown_profile-button_active'
              : ''
            }`}
        >
          <SVGIcon icon="user" />
        </button>
        {dropDownOpen && (
          <ul className="ProfileDropdown_ul">

            {auth.firstToSelectPage === false && (
              <li>
                <Link
                  to="/account"
                  className="ProfileDropdown_drop-down-button"
                >
                  <span className="ProfileDropdown_drop-down-button_inner">
                    <SVGIcon icon="account" />
                    <span>Account</span>
                  </span>
                </Link>
              </li>
            )}

            {auth.accounts.length > 1 && auth.firstToSelectPage === false
            ?( <li>
                <Link
                  to="/select-account"
                  className="ProfileDropdown_drop-down-button"
                >
                  <span className="ProfileDropdown_drop-down-button_inner">
                    <img className="ProfileDropdown_logo" src={switchImg} alt="Landmarks ID" />
                    <span>Switch account</span>
                  </span>
                </Link>
              </li>
             )
            : ''
            }

            <li>
              <button
                onClick={handelLogout}
                className="ProfileDropdown_drop-down-button"
              >
                <span className="ProfileDropdown_drop-down-button_inner">
                  <SVGIcon icon="logout" />
                  <span>Log out</span>
                </span>
              </button>
            </li>

          </ul>
        )}
      </div>
    </OutsideClickHandler>

  );
}


export default ProfileDropdown;
